export default {
    name: "Login",
    title: "Login",
    icon: "mdi-login-variant",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            childAction1: [],
            childAction2: []
        };
    },
};